import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#604596',
      light: 'rgba(96, 69, 150, 0.25)',
    },
  },
  components: {
    MuiSvgIcon: {
      defaultProps: {
        color: 'primary',
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#000',
        },
        arrow: {
          color: '#000',
        },
      },
    },
  },
});
